import { NavLink } from "react-router-dom";
import NavIcon from "./nav-icon";

const MobileNav = () => {
  const items = [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: "/icons/dashboard.svg",
    },
    {
      title: "My Wallet",
      url: "/dashboard/wallet",
      icon: "/icons/wallet.svg",
    },
    {
      title: "Cards",
      url: "/dashboard/cards",
      icon: "/icons/card.svg",
    },
    {
      title: "Transactions",
      url: "/dashboard/transactions",
      icon: "/icons/transactions.svg",
    },
    {
      title: "Partners",
      url: "/dashboard/partners",
      icon: "/icons/partners.svg",
    },
    {
      title: "Account",
      url: "/dashboard/account",
      icon: "/icons/account.svg",
    },
  ];

  return (
    <>
      <nav className="text-dark-text-100 bg-dark-background-main border-dark-stroke-5 fixed inset-x-0 bottom-0 z-15 flex w-full items-center justify-between border-t-[0.5px] px-4 py-4 font-bold backdrop-blur-sm md:hidden">
        {items
          .filter((item) => item.title !== "Report and Statements")
          .map((item) => (
            <NavLink
              end
              key={item.title}
              to={item.url}
              className={({ isActive }) =>
                `flex size-10 flex-col items-center justify-center gap-2 rounded-md ${
                  isActive ? "text-dark-primary-400" : "text-dark-text-100"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <NavIcon
                    src={item.icon}
                    isActive={isActive}
                    className="size-6"
                  />
                  <span className="text-[9px] font-light text-nowrap">
                    {item.title}
                  </span>
                </>
              )}
            </NavLink>
          ))}
      </nav>
    </>
  );
};

export default MobileNav;
